import React from 'react';
import PaymentMethodsContainer from 'containers/aio/PaymentMethodsContainer';
import NewPaymentMethodsContainer from 'containers/aio/NewPaymentMethodsContainer';
import { getEnvironment } from 'config';
import { useDeliveryMethod } from 'lib/hooks/deliveryMethod';
import Skeleton from 'containers/aio/PaymentMethodsContainer/Skeleton';

export const PaymentSection = React.forwardRef<HTMLElement>(function PaymentSection(_, ref) {
    const {
        app: { enableNewPaymentMethods },
    } = getEnvironment();
    const dm = useDeliveryMethod();

    if (!dm.hasSchedules()) {
        return <Skeleton />;
    }

    return (
        <section ref={ref}>
            {enableNewPaymentMethods ? <NewPaymentMethodsContainer /> : <PaymentMethodsContainer />}
        </section>
    );
});
